import React from 'react'
import { FaEdit, FaTrash, FaUserPlus, FaQrcode, FaTicketAlt } from "react-icons/fa"
import '../../Tickets/EventTickets.css'
const SettingsTab = ({
  newTicket,
  setNewTicket,
  showGuestTicket,
  guestTicket,
  guestTicketState,
  setShowGuestTicketForm,
  handleRemoveGuestTicket,
  setGuestTicket,
  setNotification,
  toggleLimits,
  toggleQRCode,
  editMode,
  setEditMode,
  setGuestTicketToEdit,
}) => {
  if (editMode) {
    console.log("Edit mode is active, guestTicketState:", guestTicketState)
  }

  console.log("newTicket: ", newTicket)

  const handleEditGuestTicket = () => {
    console.log("Editing guest ticket with data:", guestTicketState)

    if (setEditMode) {
      setEditMode(true)
    }

    if (setGuestTicketToEdit && guestTicketState) {
      setGuestTicketToEdit(guestTicketState)
      console.log("Setting guestTicketToEdit with:", guestTicketState)
    }

    setShowGuestTicketForm(true)
  }

  const handleAddGuestTicket = () => {
    console.log("Adding new guest ticket")

    if (setEditMode) {
      setEditMode(false)
    }

    if (setGuestTicketToEdit) {
      setGuestTicketToEdit(null)
    }

    setShowGuestTicketForm(true)
  }

  return (
    <div className="settings-tab1">
      {/* Guest Tickets Section */}
      <div className='mt-4 mb-4'>
        <div style={{ display: "flex", alignItems: "center", marginBottom: "12px", gap: "12px" }}>
          <div
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "10px",
              background: "linear-gradient(135deg, #184778 0%, #2563a8 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#ffffff",
              fontSize: "18px",
            }}
          >
            <FaUserPlus />
          </div>
          <h5 style={{ margin: 0, fontSize: "18px", fontWeight: "600", color: "#1f2937" }}>
            Guests / Accompanying Person
          </h5>
        </div>
        <p style={{ color: "#6b7280", fontSize: "14px", marginBottom: "20px", lineHeight: "1.6" }}>
          This option permits delegates selecting this ticket to include guests or companions
        </p>

        {!showGuestTicket ? (
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <button
              onClick={handleAddGuestTicket}
              style={{
                padding: "10px 24px",
                background: "linear-gradient(135deg, #184778 0%, #2563a8 100%)",
                color: "#ffffff",
                border: "none",
                borderRadius: "10px",
                fontSize: "14px",
                fontWeight: "600",
                cursor: "pointer",
                transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                boxShadow: "0 4px 12px rgba(24, 71, 120, 0.25)",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)"
                e.currentTarget.style.boxShadow = "0 6px 16px rgba(24, 71, 120, 0.35)"
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = "translateY(0)"
                e.currentTarget.style.boxShadow = "0 4px 12px rgba(24, 71, 120, 0.25)"
              }}
            >
              <FaUserPlus style={{ fontSize: "14px" }} />
              <span>Add Guest Tickets</span>
            </button>
          </div>
        ) : (
          <div
            style={{
              background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
              padding: "20px",
              borderRadius: "12px",
              border: "1px solid #e2e8f0",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)",
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
              <div style={{ flex: 1 }}>
                <div
                  style={{
                    fontSize: "12px",
                    fontWeight: "600",
                    color: "#6b7280",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    marginBottom: "8px",
                  }}
                >
                  Accompanying Person
                </div>
                <div style={{ fontSize: "16px", fontWeight: "600", color: "#1f2937", marginBottom: "6px" }}>
                  {guestTicketState?.name || "Guest Ticket"}
                </div>
                {guestTicketState?.pricingType && (
                  <div
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      padding: "4px 12px",
                      backgroundColor: guestTicketState.pricingType === "free" ? "#d1fae5" : "#dbeafe",
                      color: guestTicketState.pricingType === "free" ? "#065f46" : "#1e40af",
                      borderRadius: "20px",
                      fontSize: "13px",
                      fontWeight: "600",
                    }}
                  >
                    {guestTicketState.pricingType === "free"
                      ? "Free"
                      : guestTicketState.pricingType === "paid"
                        ? `${guestTicketState.currency} ${guestTicketState.fixedPrice || guestTicketState.variablePrices?.[0]?.price || "0"
                        }`
                        : guestTicketState.pricingType}
                  </div>
                )}
              </div>
              <div style={{ display: "flex", gap: "8px" }}>
                <button
                  onClick={handleEditGuestTicket}
                  title="Edit guest ticket"
                  style={{
                    width: "36px",
                    height: "36px",
                    borderRadius: "8px",
                    border: "1px solid #e2e8f0",
                    backgroundColor: "#ffffff",
                    color: "#184778",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "14px",
                    transition: "all 0.2s ease",
                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = "#184778"
                    e.currentTarget.style.color = "#ffffff"
                    e.currentTarget.style.borderColor = "#184778"
                    e.currentTarget.style.transform = "translateY(-1px)"
                    e.currentTarget.style.boxShadow = "0 4px 8px rgba(24, 71, 120, 0.2)"
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = "#ffffff"
                    e.currentTarget.style.color = "#184778"
                    e.currentTarget.style.borderColor = "#e2e8f0"
                    e.currentTarget.style.transform = "translateY(0)"
                    e.currentTarget.style.boxShadow = "0 1px 3px rgba(0, 0, 0, 0.1)"
                  }}
                >
                  <FaEdit />
                </button>
                <button
                  onClick={() => {
                    if (window.confirm("Are you sure you want to remove this guest ticket?")) {
                      handleRemoveGuestTicket()
                      setGuestTicket(null)
                      setNotification({
                        show: true,
                        type: "success",
                        message: "Guest ticket removed successfully!",
                      })
                    }
                  }}
                  title="Remove guest ticket"
                  style={{
                    width: "36px",
                    height: "36px",
                    borderRadius: "8px",
                    border: "1px solid #fee2e2",
                    backgroundColor: "#ffffff",
                    color: "#dc2626",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "14px",
                    transition: "all 0.2s ease",
                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = "#dc2626"
                    e.currentTarget.style.color = "#ffffff"
                    e.currentTarget.style.borderColor = "#dc2626"
                    e.currentTarget.style.transform = "translateY(-1px)"
                    e.currentTarget.style.boxShadow = "0 4px 8px rgba(220, 38, 38, 0.2)"
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = "#ffffff"
                    e.currentTarget.style.color = "#dc2626"
                    e.currentTarget.style.borderColor = "#fee2e2"
                    e.currentTarget.style.transform = "translateY(0)"
                    e.currentTarget.style.boxShadow = "0 1px 3px rgba(0, 0, 0, 0.1)"
                  }}
                >
                  <FaTrash />
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      <hr style={{ border: "none", borderTop: "1px solid #e5e7eb", margin: "32px 0" }} />

      {/* Ticket Limits Section */}
      <div style={{ marginBottom: "32px" }}>
        <div style={{ display: "flex", alignItems: "center", marginBottom: "12px", gap: "12px" }}>
          <div
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "10px",
              background: "linear-gradient(135deg, #184778 0%, #2563a8 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#ffffff",
              fontSize: "18px",
            }}
          >
            <FaTicketAlt />
          </div>
          <h5 style={{ margin: 0, fontSize: "18px", fontWeight: "600", color: "#1f2937" }}>Ticket Limit Per Order</h5>
        </div>
        <p style={{ color: "#6b7280", fontSize: "14px", marginBottom: "20px", lineHeight: "1.6" }}>
          Set minimum and maximum ticket quantity a delegate can purchase per order
        </p>

        {!newTicket.showLimits ? (
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <button
              onClick={toggleLimits}
              style={{
                padding: "10px 24px",
                background: "linear-gradient(135deg, #184778 0%, #2563a8 100%)",
                color: "#ffffff",
                border: "none",
                borderRadius: "10px",
                fontSize: "14px",
                fontWeight: "600",
                cursor: "pointer",
                transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                boxShadow: "0 4px 12px rgba(24, 71, 120, 0.25)",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)"
                e.currentTarget.style.boxShadow = "0 6px 16px rgba(24, 71, 120, 0.35)"
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = "translateY(0)"
                e.currentTarget.style.boxShadow = "0 4px 12px rgba(24, 71, 120, 0.25)"
              }}
            >
              <span>Set Limits</span>
            </button>
          </div>
        ) : (
          <>
            <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "20px" }}>
              <button
                onClick={toggleLimits}
                style={{
                  padding: "8px 20px",
                  backgroundColor: "#ffffff",
                  color: "#6b7280",
                  border: "1px solid #e5e7eb",
                  borderRadius: "8px",
                  fontSize: "13px",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = "#f9fafb"
                  e.currentTarget.style.borderColor = "#d1d5db"
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = "#ffffff"
                  e.currentTarget.style.borderColor = "#e5e7eb"
                }}
              >
                Remove Limits
              </button>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
              <div>
                <label
                  style={{
                    display: "block",
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#374151",
                    marginBottom: "8px",
                  }}
                >
                  Minimum Quantity
                </label>
                <input
                  type="number"
                  min="1"
                  value={newTicket.ticket_min_order}
                  onChange={(e) =>
                    setNewTicket({
                      ...newTicket,
                      ticket_min_order: e.target.value,
                    })
                  }
                  style={{
                    width: "100%",
                    padding: "12px 16px",
                    fontSize: "14px",
                    border: "1px solid #e5e7eb",
                    borderRadius: "8px",
                    outline: "none",
                    transition: "all 0.2s ease",
                  }}
                  onFocus={(e) => {
                    e.currentTarget.style.borderColor = "#184778"
                    e.currentTarget.style.boxShadow = "0 0 0 3px rgba(24, 71, 120, 0.1)"
                  }}
                  onBlur={(e) => {
                    e.currentTarget.style.borderColor = "#e5e7eb"
                    e.currentTarget.style.boxShadow = "none"
                  }}
                />
              </div>
              <div>
                <label
                  style={{
                    display: "block",
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#374151",
                    marginBottom: "8px",
                  }}
                >
                  Maximum Quantity
                </label>
                <input
                  type="number"
                  min="1"
                  value={newTicket.ticket_max_order}
                  onChange={(e) =>
                    setNewTicket({
                      ...newTicket,
                      ticket_max_order: e.target.value,
                    })
                  }
                  style={{
                    width: "100%",
                    padding: "12px 16px",
                    fontSize: "14px",
                    border: "1px solid #e5e7eb",
                    borderRadius: "8px",
                    outline: "none",
                    transition: "all 0.2s ease",
                  }}
                  onFocus={(e) => {
                    e.currentTarget.style.borderColor = "#184778"
                    e.currentTarget.style.boxShadow = "0 0 0 3px rgba(24, 71, 120, 0.1)"
                  }}
                  onBlur={(e) => {
                    e.currentTarget.style.borderColor = "#e5e7eb"
                    e.currentTarget.style.boxShadow = "none"
                  }}
                />
              </div>
            </div>
          </>
        )}
      </div>

      <hr style={{ border: "none", borderTop: "1px solid #e5e7eb", margin: "32px 0" }} />

      {/* QR Code Section */}
      <div className='tickets_setting_div' style={{ marginBottom: "32px" }}>
        <div >
          <div style={{ display: "flex", alignItems: "center", marginBottom: "12px", gap: "12px" }}>
            <div
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "10px",
                background: "linear-gradient(135deg, #184778 0%, #2563a8 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#ffffff",
                fontSize: "18px",
              }}
            >
              <FaQrcode />
            </div>
            <h5 style={{ margin: 0, fontSize: "18px", fontWeight: "600", color: "#1f2937" }}>QR Code</h5>
          </div>
          <p style={{ color: "#6b7280", fontSize: "14px", marginBottom: "00px", lineHeight: "1.6" }}>
            Include a QR code in this ticket for convenient access
          </p>
        </div>
        <div className="status-toggle-container" style={{ justifyContent: "flex-end" }}>
          <label className="switch">
            <input
              type="checkbox"
              className="lv-btn small-switch"
              checked={newTicket.qrcode}
              onChange={toggleQRCode}
            />
            <span className="slider round"></span>
          </label>
        </div>

      </div>
    </div>
  )
}

export default SettingsTab
